module.exports = __webpack_public_path__ + "img/title-zh.2d8d14ba.png";